export const drawerPaperStyles = {
  borderRadius: '28px 28px 0 0',
  backgroundColor: ({ palette }) => palette.background.paper,
  backdropFilter: 'saturate(180%) blur(22px)',
  WebkitBackdropFilter: 'saturate(180%) blur(22px)',
  borderTop: '1px solid',
  borderColor: ({ palette }) => palette.divider,
  paddingBottom: 'env(safe-area-inset-bottom, 16px)',
  maxHeight: '88vh',
  overflow: 'auto',
};

export const grabberStyles = {
  width: '38px',
  height: '5px',
  borderRadius: '999px',
  backgroundColor: ({ palette }) => palette.action.disabled,
  margin: '8px auto 12px',
};

export const sheetHeaderStyles = {
  padding: '0 16px 8px',
};

export const itemButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  width: '100%',
  minHeight: '54px',
  padding: '8px 16px',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  borderBottom: '1px solid',
  borderColor: ({ palette }) => palette.divider,
  textAlign: 'left',
  WebkitTapHighlightColor: 'transparent',
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:active': {
    backgroundColor: ({ palette }) => palette.action.selected,
  },
};

export const themeRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '14px',
  width: '100%',
  minHeight: '54px',
  padding: '8px 16px',
};

export const iconWrapperStyles = {
  width: '38px',
  height: '38px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.action.hover,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: 'text.secondary',
};

export const expandIconStyles = {
  marginLeft: 'auto',
  flexShrink: 0,
  color: 'text.secondary',
};

export const childItemIndentStyles = {
  pl: 2,
};
